import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Button from "../../../Other/element/Button";

// Set the workerSrc for pdfjs
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ChapterDocument = ({ url, type, closeHandler, show }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [errorOccurred, setErrorOccurred] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const onDocumentError = (error) => {
    console.error("PDF Error:", error);
    setErrorOccurred(true);
  };

  const downloadFile = () => {
    const aTag = document.createElement("a");
    aTag.href = url;
    aTag.download = "document.pdf";
    document.body.appendChild(aTag);
    aTag.click();
    document.body.removeChild(aTag);
  };

  return (
    <>
      {show && (
        <div
          className="modal fade show d-block"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="course_modal-dialog modal-lg">
            <div className="course_modal-content file-viewer-content model-center">
              <div className="course_modal-header d-flex justify-content-between align-items-center p-2">
                <Button
                  handleClick={closeHandler}
                  title="Close"
                  className="btn btn-danger close-file"
                />
                <Button
                  handleClick={downloadFile}
                  title="Download"
                  className="btn btn-primary"
                />
              </div>

              <div className="course_modal-body file-viewer-body p-3 text-center">
                {!errorOccurred ? (
                  <>
                    <Document
                      file={url}
                      onLoadSuccess={onDocumentLoadSuccess}
                      onLoadError={onDocumentError}
                      loading={<p>Loading PDF...</p>}
                    >
                      <Page pageNumber={pageNumber} />
                    </Document>
                    <div className="mt-3">
                      <Button
                        handleClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}
                        title="Previous"
                        className="btn btn-secondary me-2"
                      />
                      <span>
                        Page {pageNumber} of {numPages}
                      </span>
                      <Button
                        handleClick={() => pageNumber < numPages && setPageNumber(pageNumber + 1)}
                        title="Next"
                        className="btn btn-secondary ms-2"
                      />
                    </div>
                  </>
                ) : (
                  <div className="text-danger text-center">
                    ❌ Failed to load PDF. <br />
                    Try downloading it directly:
                    <Button
                      handleClick={downloadFile}
                      title="Download PDF"
                      className="btn btn-warning mt-2"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChapterDocument;
